import { Routes } from '@angular/router';
import { FlashNumberPage } from './flash-number/flash-number-page';
import { FormulePage } from './formule-page';
import { FlashCountingPage } from './flash-counting/flash-counting-page';
import { FlashCountingCategorizedPage } from './flash-counting-categorized/flash-counting-categorized-page';
import { SplittingPage } from './splitting/splitting-page';
import { MathPage } from './math/math-page';
import { FlashAmountPage } from './flash-amount/flash-amount-page.component';
import { NumberWritingPage } from './number-writing/number-writing-page';
import { ComparePage } from './compare/compare-page.component';
import { EggCartonSumsPage } from './egg-carton-sums/egg-carton-sums-page';

export const formuleRoutes: Routes = [
  {
    path: '',
    component: FormulePage,
  },
  {
    path: 'flash-number',
    component: FlashNumberPage,
  },
  {
    path: 'flash-counting',
    component: FlashCountingPage,
  },
  {
    path: 'flash-amount',
    component: FlashAmountPage,
  },
  {
    path: 'flash-counting-categorized',
    component: FlashCountingCategorizedPage,
  },
  {
    path: 'splitting',
    component: SplittingPage,
  },
  {
    path: 'math',
    component: MathPage,
  },
  {
    path: 'number-writing',
    component: NumberWritingPage,
  },
  {
    path: 'compare',
    component: ComparePage,
  },
  {
    path: 'egg-carton-sums',
    component: EggCartonSumsPage,
    data: { typedAnswers: true },
  },
  {
    path: 'egg-carton-sums-click',
    component: EggCartonSumsPage,
    data: { typedAnswers: false },
  },
];
